"use client";

import { ColumnDef } from "@tanstack/react-table";

import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";

// import { labels, priorities, statuses } from "../data/data";
import { DataTableColumnHeader } from "../../../components/shared/data-table/data-table-column-header";

//import { DataTableRowActions } from "./data-table-row-actions";

// account_code
// role
// price_listId
// price_list {
//   name
// }
// customer_groupId
// customer_group {
//   name
// }
// language
// is_b2b_user
// id
// name
// email
// b2b_company_address {
//   country
// }

export const columns: any[] = [
  // {
  //   id: "select",
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && "indeterminate")
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label="Select all"
  //       className="translate-y-[2px]"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label="Select row"
  //       className="translate-y-[2px]"
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => <div className="max-w-[10px]">{row.getValue("id")}</div>,
    enableSorting: false,
    enableHiding: true,
    size: 10,
    maxSize: 10,
  },
  {
    accessorKey: "name",
    id: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    enableSorting: false,
    enableHiding: true,
    minSize: 100,
    size: 800,

    cell: ({ row }) => {
      return (
        <div className="flex space-x-2">
          <span className="max-w-[500px] truncate font-medium">
            {row.getValue("name")}
          </span>
        </div>
      );
    },
  },

  {
    accessorKey: "fabric_palettes",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Palettes" />
    ),
    cell: ({ row }) => {
      const palettes = row.getValue("fabric_palettes") || [];
      return (
        <div className="flex flex-wrap gap-1">
          {palettes.map((palette: any) => (
            <Badge key={palette.id} variant="outline" className="text-xs">
              {palette.name}
            </Badge>
          ))}
        </div>
      );
    },
  },
  // {
  //   accessorKey: "customer_group.name",
  //   id: "customer_group.name",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Group" />
  //   ),
  //   enableSorting: true,
  //   enableHiding: true,
  //   id: "customer_group.name",
  //   cell: ({ row }) => {
  //     if (!row.getValue("customer_group.name")) {
  //       return null;
  //     }
  //     return (
  //       <Badge variant="secondary" className="text-xs">
  //         {row.getValue("customer_group.name")}
  //       </Badge>
  //     );
  //   },
  // },
  {
    accessorKey: "price_list",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Price List" />
    ),
    cell: ({ row }) => {
      const priceList = row.getValue("price_list");
      if (!priceList) {
        return null;
      }
      return (
        <div className="flex min-w-[100px]">
          <Badge variant="secondary" className="text-xs">
            {priceList.name}
          </Badge>
        </div>
      );
    },
    enableSorting: true,
    enableHiding: true,
    enableResizing: false,
    minSize: 200,
    size: 200,
    maxSize: 200,
  },
];
